import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MaskedInput from 'react-text-mask';
import { SovosTextField, SovosIconButton, colors } from 's1-ui';
import { Delete } from '@material-ui/icons';
import Button from '@material-ui/core/Button';

const { blueMedium, redMedium } = colors;

const styles = {
  addAccount: {
    textTransform: 'none',
    color: blueMedium
  }
};
// eslint-disable-next-line arrow-body-style
const getOnChange = (parentValue, parentOnChange, index) => {
  return function arrayIndexOnChange(newValue) {
    const setValue = newValue === '' ? undefined : newValue;
    const array = [...parentValue];
    array[index] = setValue;
    if (array.length === 1 && array[0] == null) {
      parentOnChange(undefined);
    } else {
      parentOnChange(array);
    }
  };
};

const addAccount = (value, onChange) => {
  onChange([...value, undefined]);
};

const deleteAccount = (accountValue, onChange, accountIndex) => {
  const filteredArray = accountValue.filter((account, index) => index !== accountIndex);
  onChange(filteredArray);
};

function AccountMask(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      { ...other }
      ref={ ref => inputRef(ref ? ref.inputElement : null) }
      mask={ [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/] }
      placeholderChar="_"
    />
  );
}

const CarrierAccountsField = ({
  value, onChange, error, underline, index, accountValue, deleteChange, numberOfAccounts
}) => {
  const errorBool = error !== undefined;
  return (
    <div style={ {
      width: '400px', marginRight: '100px', display: 'flex', alignItems: 'center', paddingBottom: 20
    } }
    >
      <SovosTextField
        InputProps={ {
          placeholder: 'FedEx Account Number',
          error: errorBool,
          inputComponent: AccountMask
        } }
        error={ errorBool }
        helperText={ error }
        style={ { width: 360 } }
        label="FedEx account number(s)"
        value={ value }
        classes={ { underline } }
        onChange={ e => onChange(e.target.value) }
      />
      { numberOfAccounts > 1 && (
      <SovosIconButton
        onClick={ () => deleteAccount(accountValue, deleteChange, index) }
        color={ redMedium }
      >
        <Delete />
      </SovosIconButton>
      )}
    </div>
  );
};

export const UnstyledAccountNumbersField = ({
  value, errors, onChange, underline, classes
}) => {
  const accountList = value.length > 0 ? value : [undefined];
  return (
    <div>
      { accountList.map((account, index) => {
        let error;
        if (errors !== undefined) {
          error = errors ? errors[index] : undefined;
        }
        const accountKey = `account-${index}`;
        return (
          <CarrierAccountsField
            numberOfAccounts={ value.length }
            error={ error }
            accountValue={ value }
            value={ account }
            underline={ underline }
            index={ index }
            key={ accountKey }
            onChange={ getOnChange(value, onChange, index) }
            deleteChange={ onChange }
          />
        );
      })}
      <Button
        onClick={ () => addAccount(value, onChange) }
        classes={ { root: classes.addAccount } }
      >
        + add another account
      </Button>
    </div>
  );
};

UnstyledAccountNumbersField.propTypes = {
  value: PropTypes.array,
  errors: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  underline: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired
};

UnstyledAccountNumbersField.defaultProps = {
  value: [undefined],
  errors: undefined
};

CarrierAccountsField.propTypes = {
  numberOfAccounts: PropTypes.number.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  underline: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  accountValue: PropTypes.array.isRequired,
  deleteChange: PropTypes.func.isRequired,
};

CarrierAccountsField.defaultProps = {
  value: '',
  error: undefined
};

export default withStyles(styles)(UnstyledAccountNumbersField);
